const ENV = localStorage.getItem('ENV') || process.env.REACT_APP_ENV;
export default ENV;
